import Entity from '../entity'
export default class CourtService extends Entity<number>{
    name: string = "";
    offerId: number = 0;
}